
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEsimIcon2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 121,
  height: 120,
  viewBox: "0 0 121 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M84.036 22H47.903c-1.35 0-2.642.55-3.577 1.522l-10.94 11.37A4.964 4.964 0 0 0 32 38.334v53.543C32 95.259 34.791 98 38.234 98h44.532C86.209 98 89 95.259 89 91.877v-64.92A4.958 4.958 0 0 0 84.036 22Z",
  stroke: "#000",
  strokeWidth: 3.694,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M51.19 65.652c-2.09 0-3.971-.76-4.883-1.653l1.349-2.242c.608.475 2.147 1.159 3.8 1.159.76 0 1.463-.228 1.463-.779 0-1.368-6.137-.646-6.137-4.617 0-2.09 1.805-3.306 4.256-3.306 1.995 0 3.629.893 4.389 1.71l-1.54 1.767c-.76-.627-1.71-.988-2.925-.988-.456 0-1.16.171-1.16.684 0 1.368 6.043.684 6.043 4.693 0 2.318-1.843 3.572-4.655 3.572Zm6.094-.152V54.328h2.888V65.5h-2.888Zm4.824 0V54.328h2.584l3.42 6.707 3.477-6.707h2.603V65.5h-2.755v-5.643l-2.375 4.693h-1.957l-2.242-4.579V65.5h-2.755Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M77.39 69.754v9.709a1.76 1.76 0 0 1-1.76 1.76H45.37a1.76 1.76 0 0 1-1.759-1.76v-9.709m0-20.329V40.76c0-.971.788-1.759 1.76-1.759H75.63c.972 0 1.76.788 1.76 1.76v8.665",
  stroke: "#000",
  strokeWidth: 3.694,
  strokeLinecap: "round"
})));

      const __svgRaw = "<svg width=\"121\" height=\"120\" viewBox=\"0 0 121 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M84.0359 22L47.9029 22C46.5531 22 45.2615 22.5497 44.3256 23.5224L33.3869 34.8918C32.497 35.8167 32 37.0502 32 38.3336L32 91.8769C32 95.2586 34.7912 98 38.2344 98L82.7656 98C86.2088 98 89 95.2586 89 91.8769L89 26.9568C89 24.2152 86.7775 22 84.0359 22Z\" stroke=\"black\" stroke-width=\"3.69444\" stroke-linecap=\"round\"/>\r\n<path d=\"M51.1897 65.652C49.0997 65.652 47.2187 64.892 46.3067 63.999L47.6557 61.757C48.2637 62.232 49.8027 62.916 51.4557 62.916C52.2157 62.916 52.9187 62.688 52.9187 62.137C52.9187 60.769 46.7817 61.491 46.7817 57.52C46.7817 55.43 48.5867 54.214 51.0377 54.214C53.0327 54.214 54.6667 55.107 55.4267 55.924L53.8877 57.691C53.1277 57.064 52.1777 56.703 50.9617 56.703C50.5057 56.703 49.8027 56.874 49.8027 57.387C49.8027 58.755 55.8447 58.071 55.8447 62.08C55.8447 64.398 54.0017 65.652 51.1897 65.652ZM57.2841 65.5V54.328H60.1721V65.5H57.2841ZM62.1083 65.5V54.328H64.6923L68.1123 61.035L71.5893 54.328H74.1923V65.5H71.4373V59.857L69.0623 64.55H67.1053L64.8633 59.971V65.5H62.1083Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M77.3891 69.7545V79.463C77.3891 80.4346 76.6015 81.2222 75.6298 81.2222H45.3706C44.399 81.2222 43.6113 80.4346 43.6113 79.463V69.7545M43.6113 49.4252V40.7593C43.6113 39.7876 44.399 39 45.3706 39H75.6299C76.6015 39 77.3891 39.7876 77.3891 40.7593V49.4252\" stroke=\"black\" stroke-width=\"3.69444\" stroke-linecap=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/esim-icon2.5a82c08c4dcd93f4a3eb85b28b85c947.svg"),
        {
          React: SvgEsimIcon2,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      